import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/antd.min.css";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./Routes/Routes";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <AppRoutes />
      <ToastContainer theme="colored" />
    </div>
  );
}

export default App;